import { useMutation } from "@apollo/client";
import { analytics } from "MVVM/Analytics";
import {
  MOMENT_REQUEST_CLIP,
  MOMENT_CREATE_CLIP,
} from "MVVM/GraphQL/mutations/momentRequestClip";

export const MomentViewModel = () => {
  const [momentRequestClip] = useMutation(MOMENT_REQUEST_CLIP, {
    onError: (err: any) => {
      console.log(`mutateReaction error! ${err.message}`);
    },
  });

  const [momentCreateClip] = useMutation(MOMENT_CREATE_CLIP, {
    onError: (err: any) => {
      analytics.track("MomentCreateClipError", {
        errorMessage: err.message,
      });
    },
  });

  return {
    momentRequestClip,
    momentCreateClip,
  };
};
